import { IsoLocale } from './iso-locale.js';

let Locale = /*#__PURE__*/function (Locale) {
  Locale["sv_SE"] = "sv_SE";
  Locale["sv_FI"] = "sv_FI";
  Locale["da_DK"] = "da_DK";
  Locale["fi_FI"] = "fi_FI";
  Locale["nb_NO"] = "nb_NO";
  Locale["en_GB"] = "en_GB";
  Locale["de_DE"] = "de_DE";
  Locale["es_ES"] = "es_ES";
  Locale["es_MX"] = "es_MX";
  Locale["pt_BR"] = "pt_BR";
  Locale["nl_NL"] = "nl_NL";
  Locale["fr_FR"] = "fr_FR";
  Locale["it_IT"] = "it_IT";
  Locale["en_US"] = "en_US";
  Locale["es_US"] = "es_US";
  return Locale;
}({});
const LocaleToIsoLocale = new Map([[Locale.sv_SE, IsoLocale.svSE], [Locale.sv_FI, IsoLocale.svFI], [Locale.da_DK, IsoLocale.daDK], [Locale.fi_FI, IsoLocale.fiFI], [Locale.nb_NO, IsoLocale.nbNO], [Locale.en_GB, IsoLocale.enGB], [Locale.de_DE, IsoLocale.deDE], [Locale.es_ES, IsoLocale.esES], [Locale.es_MX, IsoLocale.esMX], [Locale.pt_BR, IsoLocale.ptBR], [Locale.nl_NL, IsoLocale.nlNL], [Locale.fr_FR, IsoLocale.frFR], [Locale.it_IT, IsoLocale.itIT], [Locale.en_US, IsoLocale.enUS], [Locale.es_US, IsoLocale.esUS]]);
const toIsoLocale = locale => LocaleToIsoLocale.get(locale);
const fromIsoLocale = isoLocale => {
  const foundPair = [...LocaleToIsoLocale.entries()].find(_ref => {
    let [_key, value] = _ref;
    return value === isoLocale;
  });
  return foundPair?.[0];
};

export { Locale, fromIsoLocale, toIsoLocale };
//# sourceMappingURL=locale.js.map
